import { render, staticRenderFns } from "./FanIcon.vue?vue&type=template&id=04d21061"
import script from "./FanIcon.vue?vue&type=script&lang=ts"
export * from "./FanIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports